<template>
  <component :is="bannerComponent" />
</template>

<script>
import VetsterPlusBenefitsBanner from '@/brand-components/GuidedSearch/VetsterPlusBenefitsBanner';
import VetsterProductCategoryBanner from '@/brand-components/GuidedSearch/VetsterProductCategoryBanner';

export default {
  name: 'VetsterSearchBanner',

  computed: {
    bannerComponent() {
      return this.isAllergiesCategoryEnabled
        ? VetsterProductCategoryBanner
        : VetsterPlusBenefitsBanner;
    },
    isAllergiesCategoryEnabled() {
      // Enabled for US VCPR regions
      return this.$statsig.ready && this.$statsig.checkGate('booking_allergy_questionnaire');
    },
  },
};
</script>
